// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLPartnerCarrierChoicesComponent__choiceLabel{font-size:14px}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-gateway-react/Components/MLPartnerCarrierPopup/MLPartnerCarrierChoicesComponent.module.scss"],"names":[],"mappings":"AAAA,oDACI,cAAA","sourcesContent":[".choiceLabel {\n    font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"choiceLabel": "app__MLPartnerCarrierChoicesComponent__choiceLabel"
};
export default ___CSS_LOADER_EXPORT___;
